import { SouvenirsImagesModel } from "./SouvenirsImagesModel";

export class SouvenirsModel{
    id?: number;
    nameAr?:string;
    nameEn?:string;
    nameFr?:string;
    descriptionAr?:string;
    descriptionEn?:string;
    descriptionFr?:string;
    countryId?: number;
    userId?: number;
    souvenirImagesList?:SouvenirsImagesModel[]
    images?:string;
    countryNameAr?:string;
    countryNameEn?:string;



    constructor(item?:SouvenirsModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.images = item.images? item.images:'';
        this.nameAr = item.nameAr? item.nameAr:'';
        this.nameEn = item.nameEn? item.nameEn:'';
        this.nameFr = item.nameFr? item.nameFr:'';
        this.descriptionAr = item.descriptionAr? item.descriptionAr:'';
        this.descriptionEn = item.descriptionEn? item.descriptionEn:'';
        this.descriptionFr = item.descriptionFr? item.descriptionFr:'';
        this.countryId = item.countryId? item.countryId:0;
        this.userId = item.userId? item.userId:0;
        this.souvenirImagesList = item.souvenirImagesList? item.souvenirImagesList:[];
        this.countryNameAr = item.countryNameAr? item.countryNameAr:'';
        this.countryNameEn = item.countryNameEn? item.countryNameEn:'';

    }

}